import { render, staticRenderFns } from "./TextBody.vue?vue&type=template&id=06f3df37&scoped=true"
var script = {}
import style0 from "./TextBody.vue?vue&type=style&index=0&id=06f3df37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f3df37",
  null
  
)

export default component.exports